// extracted by mini-css-extract-plugin
export default {"container":"ZK-z","topReviewHeading":"_K-z","criticalReview":"aL-z","favorableReview":"bL-z","vsSeparator":"cL-z"};